import { apiSlice } from "../../app/api/apiSlice";

export const JoinTableApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getJoiningTables: builder.mutation({
      query: (object) => ({
        url: "/modelling/schematables",
        method: "POST",
        body: object,
      }),
    }),
    getTableColumns: builder.mutation({
      query: (object) => ({
        url: "/modelling/baseAndNewTablesColumns",
        method: "POST",
        body: object,
      }),
    }),
    getSchemas: builder.mutation({
      query: () => ({
        url: "/modelling/getSchemas",
        method: "POST",
      }),
    }),
    previewTable: builder.mutation({
      query: (object) => ({
        url: "/modelling/previewtable",
        method: "POST",
        body: object,
      }),
    }),
    join: builder.mutation({
      query: (object) => ({
        url: "/modelling/createNewJoin",
        method: "POST",
        body: object,
      }),
    }),
    getRelations: builder.mutation({
      query: (object) => ({
        url: "/modelling/getRelations",
        method: "POST",
        body: object,
      }),
    }),
    deleteRelation: builder.mutation({
      query: (object) => ({
        url: "/modelling/deleteRelation",
        method: "DELETE",
        body: object,
      }),
    }),
    editRelation: builder.mutation({
      query: (object) => ({
        url: "/modelling/editRelation",
        method: "PUT",
        body: object,
      }),
    }),
    resetTempDataSource: builder.mutation({
      query: (object) => ({
        url: "/modelling/resetTempDataSource",
        method: "POST",
        body: object,
      }),
    }),
    updateBaseTable: builder.mutation({
      query: (object) => ({
        url: "/modelling/updateBaseTable",
        method: "Post",
        body: object,
      }),
    }),
    commitDataSource: builder.mutation({
      query: (object) => ({
        url: "/modelling/commitDatasource",
        method: "Post",
        body: object,
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetJoiningTablesMutation,
  useGetTableColumnsMutation,
  useGetSchemasMutation,
  usePreviewTableMutation,
  useJoinMutation,
  useGetRelationsMutation,
  useDeleteRelationMutation,
  useEditRelationMutation,
  useResetTempDataSourceMutation,
  useUpdateBaseTableMutation,
  useCommitDataSourceMutation,
} = JoinTableApiSlice;
